import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

export default mockComponentRenderProp('DropHover', null, { withChildren: true });
